<script>
export default {
  inheritAttrs: false,
  props: {
    starRating: {
      type: [Number, null],
      default: null,
    },
    leastStarDescription: {
      type: [String, null],
      default: '',
    },
    mostStarDescription: {
      type: [String, null],
      default: '',
    },
  },
  data() {
    return {
      modelStarRating: this.starRating,
      hoverValue: 0,
      isHovering: 0,
    }
  },
  computed: {},
  watch: {
    starRating: {
      handler: function (newVal) {
        this.modelStarRating = newVal
      },
    },
  },
  methods: {
    updateStarRating(newRating) {
      this.modelStarRating = newRating
      this.$emit('star-rating', parseInt(newRating))
    },
    isFilled(star) {
      if (this.isHovering) {
        return star <= this.hoverValue
      }

      return star <= this.modelStarRating
    },
  },
}
</script>

<template>
  <div>
    <div :class="$style.starDescriptions">
      <p class="p2">{{ leastStarDescription }}</p>
      <p class="p2">{{ mostStarDescription }}</p>
    </div>
    <div :class="$style.starRatingContainer">
      <div
        v-for="star in [1, 2, 3, 4, 5]"
        :key="star"
        :class="$style.star"
        @click="updateStarRating(star)"
        @mouseenter="
          () => {
            hoverValue = star
            isHovering = true
          }
        "
        @mouseleave="
          () => {
            isHovering = false
          }
        "
        ><BaseIcon :name="{ prefix: isFilled(star) ? 'fas' : 'far', iconName: 'star' }"></BaseIcon
      ></div>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.starRatingContainer {
  display: flex;
  justify-content: space-around;
  width: 100%;
  font-size: 24px;
}

.star {
  color: $primary-blue;
  cursor: pointer;
}

.starDescriptions {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  width: 100%;

  p {
    max-width: 120px;
    margin: 0 20px;
  }

  p:nth-child(2) {
    text-align: right;
  }
}
</style>
